import { types } from 'mobx-state-tree';

const OrderOriginType = {
  NETSTORE: 'NETSTORE',
  IN_STORE: 'IN_STORE',
};

export default OrderOriginType;

export const OrderOriginTypeType = types.enumeration(
  'OrderOriginTypeType',
  Object.values(OrderOriginType)
);
